import {Outlet} from 'react-router-dom'
import {StyledPrivateLayout, StyledPrivateLayoutContent} from './style.ts'
import {Navbar} from '@components/commons/navbar/Navbar.tsx'
import {InternalConversationsProvider} from '@/features/conversations/components/internal-conversations-provider/InternalConversationsProvider'
import {NotificationContextBarHost} from '@/features/notifications/components/notification-context-bar-host/NotificationContextBarHost'

export const PrivateLayout = () => {
    return (
        <StyledPrivateLayout>
            <Navbar />
            {/* The work-context bar gets its own row above the routed page, so it reserves its
                height instead of covering the page header — which stays visible and reachable
                for the whole life of a task */}
            <StyledPrivateLayoutContent>
                <NotificationContextBarHost />
                <Outlet />
            </StyledPrivateLayoutContent>
            {/* Internal conversations drawer: mounted once for every authenticated route
                so it survives navigation and can be opened from the account menu or
                from conversation notifications without a link */}
            <InternalConversationsProvider />
        </StyledPrivateLayout>
    )
}
